import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { ColumnHeaders } from '../../model/ColumnHeaders.model';
import { filterPredicate } from '../../consts/filterPredicate.const';
import { UserRepairerSite } from '../../model/user.model';
import { sortingDataAccessor } from '../../consts/sortFunction.const';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '../../pipes/date.pipe';
import { TimePipe } from '../../pipes/time.pipe';
import { ObjectDeepValuePipe } from '../../pipes/objectDeepValue.pipe';
import { KebabMenuListPipe } from '../../pipes/kebabMenuList.pipe';
import { StatusCellInfoComponent } from './status-cell-info/status-cell-info.component';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { REPAIRER_SITES_KEBAB_OPTIONS } from '../../dashboard/sysadmin-dashboard/repairer-sites/repairer-sites.const';

@Component({
  selector: 'app-repairer-site-table',
  imports: [
    CommonModule,
    StatusCellInfoComponent,
    MatMenuModule,
    MatExpansionModule,
    MatSortModule,
    MatIconModule,
    DatePipe,
    TimePipe,
    ObjectDeepValuePipe,
    KebabMenuListPipe,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule
  ],
  templateUrl: './repairer-site-table.component.html',
  styleUrls: ['./repairer-site-table.component.scss']
})
export class RepairerSiteTableComponent implements OnChanges {
  @Input() currentTab: string;
  @Input() columnInfos: ColumnHeaders[];
  @Input() activeColumn: string;
  @Input() loadingRepairers: boolean;
  @Input() currentUserTimezone: string;
  @Input() repairerSites: UserRepairerSite[];
  @Output() columnHeaderOrderChange = new EventEmitter();
  @Output() kebabMenuClicked = new EventEmitter();
  @Output() rowItemClicked = new EventEmitter();
  @ViewChild('tableSort', { static: true }) matSort: MatSort;
  columnHeaders: string[];
  tableDataSource: MatTableDataSource<UserRepairerSite>;
  kebabMenuButtons: { label: string; action: string }[] = [...REPAIRER_SITES_KEBAB_OPTIONS];

  ngOnChanges() {
    this.columnHeaders = this.columnInfos?.map((col) => col.matColumnDef);
    this.tableDataSource = new MatTableDataSource(this.repairerSites);
    this.tableDataSource.sortingDataAccessor = sortingDataAccessor;
    this.tableDataSource.sort = this.matSort;
    this.tableDataSource.filterPredicate = filterPredicate;
  }
}
